import { useContext } from "react";
import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { UploadDocumentsContext } from "../UploadDocuments";
import { ArrowLeft, ArrowLeftCircle, List } from "react-feather";
import { useNavigate } from "react-router-dom";


export default function DocumentHeader(){

    const {
        invoiceData,
    } = useContext(UploadDocumentsContext) ?? {}

    const navigate = useNavigate()

    return (
        <Row className="d-flex justify-content-between align-middle">
            <Col className="d-flex align-middle align-items-center">
                <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Return to Invoice List</Tooltip>}
                >
                    <ArrowLeftCircle
                        style={{ cursor: "pointer" }}
                        size="30"
                        onClick={() => navigate('/tms/invoices')}
                        color="blue"
                        className="align-middle"
                    />
                </OverlayTrigger>
                <h1 className="m-0 ms-3">{invoiceData?.number} Attached Documents</h1>
            </Col>
        </Row>
    )
}